export default "__VITE_ASSET__CZzHcSpr__"